export const formatCount = (count: any): string => {
  return count?.toString() ?? "0";
};
